import { render, staticRenderFns } from "./ReportModal.vue?vue&type=template&id=3ffb234b&scoped=true&"
import script from "./ReportModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReportModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb234b",
  null
  
)

export default component.exports